// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"9cd24b48","259":"1faae8c6","317":"d5c15d1a","453":"88453926","584":"749542bf","684":"9a1d4955","694":"f921dded"}[chunkId] + ".chunk.js";
};